import LocalizedStrings from 'localized-strings';

import { TeamMemberRole } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    ctaLabel: 'Revoke access',
    description: {
      [TeamMemberRole.Accountant]:
        'To invite them again, go to the "Revoked" section on the team management page.',
      [TeamMemberRole.Admin]: '',
      [TeamMemberRole.Employee]:
        'By revoking access, all their cards (physical and virtual) will be automatically deactivated. They will no longer have access to the account.\n\nTo invite them again, go to the "Revoked" section on the team management page.',
      [TeamMemberRole.AccountHolder]: '',
      [TeamMemberRole.None]: '',
    },
    success: '{firstName} {lastName} has been successfully revoked',
    title: 'You are about to revoke access to {firstName} {lastName}',
  },
  fr: {
    cancel: 'Annuler',
    ctaLabel: 'Révoquer ses accès',
    description: {
      [TeamMemberRole.Employee]:
        'En supprimant ses accès, toutes ses cartes (physiques et virtuelles) seront automatiquement désactivées. Ce membre n’aura plus accès au compte.\n\nPour l’inviter à nouveau, rendez-vous dans la section “Révoqué·es” sur la page de gestion de l’équipe.',
      [TeamMemberRole.Accountant]:
        'Pour l’inviter à nouveau, rendez-vous dans la section “Révoqué·es” sur la page de gestion de l’équipe.',
      [TeamMemberRole.Admin]: '',
      [TeamMemberRole.AccountHolder]: '',
      [TeamMemberRole.None]: '',
    },
    success: 'Les accès de {firstName} {lastName} ont bien été révoqués',
    title:
      'Vous êtes sur le point de révoquer les accès de {firstName} {lastName}',
  },
});

export default locales;
